import CloseIcon from '@mui/icons-material/Close';
import { addDays, format } from 'date-fns';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import RosterApi from '../../../axios/Roster/RosterApi';
import CustomInput from '../../../components/CustomInput';
import { ControlpanelPrimaryButton, ControlpanelSecondaryButton, GrayIconButton } from '../../../components/StyledButton';
import { CustomDialog } from '../../../components/StyledComponents';
import { useLoading } from '../../../context/LoadingContext';
import { useSettings } from '../../../context/SettingsContext';
import CustomAutocomplete from '../../../components/CustomAutocomplete';
import CustomSelect from '../../../components/CustomSelect';
import DeviceApi from '../../../axios/Device/DeviceApi';
import SaveIcon from '@mui/icons-material/Save';
import {
   Checkbox,
   DialogActions,
   DialogContent,
   DialogTitle,
   FormControl,
   FormControlLabel,
   FormGroup,
   Radio,
   RadioGroup,
} from '@mui/material';

const RegistersDeviceDialog = ({ onClose, onRefresh, GroupData, usersData }) => {
   // const { open, handleClose, onRefresh, allUser, onChangeAllUser, status} = props;
   const [show, hide] = useLoading();
   const { addRoster } = RosterApi();
   const { t } = useTranslation();
   const { addDevice } = DeviceApi()

   // const usersData = [
   //    {
   //       employeeCode: "29A",
   //       firstName: "Tú",
   //       lastName: "Huỳnh Thị Cẩm",
   //       userId: 1049,
   //       email: "tuhtc@mobile-id.vn"
   //    },
   //    {
   //       employeeCode: "11A",
   //       firstName: "Nghĩa",
   //       lastName: "Trần Thị",
   //       userId: 18001,
   //       email: "nghiatt@mobile-id.vn"
   //    },
   //    {
   //       employeeCode: "38A",
   //       firstName: "Triệu",
   //       lastName: "Phan Ngọc",
   //       userId: 1054,
   //       email: "trieupn@mobile-id.vn",
   //    },
   //    {
   //       employeeCode: "34A",
   //       firstName: "Cường",
   //       lastName: "Huỳnh Quang",
   //       userId: 1044,
   //       email: "cuonghq@mobile-id.vn",
   //    },
   //    {
   //       employeeCode: "7dRyys",
   //       firstName: "Ngân",
   //       lastName: "Ngô Thị Thanh",
   //       userId: 21001,
   //       email: "nganntt@mobile-id.vn",
   //    },
   //    {
   //       employeeCode: "56A",
   //       firstName: "Trâm",
   //       lastName: "Đặng Bảo",
   //       userId: 1059,
   //       email: "tramdb@mobile-id.vn",
   //    },
   //    {
   //       employeeCode: "30A",
   //       firstName: "Phát",
   //       lastName: "Trương Hồng",
   //       userId: 1004,
   //       email: "phatth@mobile-id.vn",
   //    },
   //    {
   //       employeeCode: "1A",
   //       firstName: "Tâm",
   //       lastName: "Đoàn Quang",
   //       userId: 1029,
   //       email: "tamdq@mobile-id.vn",
   //    },
   //    {
   //       employeeCode: "59a",
   //       firstName: "Vũ",
   //       lastName: "Phan Xuân",
   //       userId: 3001,
   //       email: "vupx@mobile-id.vn",
   //    },
   //    {
   //       employeeCode: "37A",
   //       firstName: "Mi",
   //       lastName: "Trần Đinh Diệu",
   //       userId: "1019",
   //       email: "mitdd@mobile-id.vn",
   //    }
   // ];

   const initialFormData = {
      userId: '',
      ip: '',
      brand: '',
      port: '',
      deviceSn: '',
      deviceAttribute: '',
      description: '',
      group: '',
   };


   const [formData, setFormData] = useState(initialFormData);
   const [errors, setErrors] = useState({ port: '' });




   const handleCloseDialog = () => {
      setFormData(initialFormData);

      onClose();
      setErrors(prev => ({ ...prev, port: '' }));
   };

   const handleDataChange = (name, newData) => {
      setFormData((prevData) => ({
         ...prevData,
         [name]: newData,
      }));
   };
   // const handleInputChange = (e) => {
   //    const { name, value } = e.target;
   //    setFormData((prevData) => ({
   //       ...prevData,
   //       [name]: value,
   //    }));
   // };

   // const [formData, setFormData] = useState({ port: '' });


   const handleInputChange = (e) => {
      const { name, value } = e.target;

      if (name === 'port') {
         if (/^\d*$/.test(value)) {
            setFormData(prev => ({ ...prev, [name]: value }));
            setErrors(prev => ({ ...prev, port: '' }));
         } else {
            setErrors(prev => ({ ...prev, port: t('common.valid-number') }));
         }
      } else {
         setFormData(prev => ({ ...prev, [name]: value }));
      }
   };
   const [selectUserOrGroup, setSelectUserOrGroup] = useState(0);

   const handleChangeSelectUserOrGroup = (event) => {
      setSelectUserOrGroup(Number(event.target.value));
   };




   const handleSubmit = async (e) => {
      let user = 0;
      let groupId = 0;
      if (selectUserOrGroup === 1) {
         user = formData.userId.userId
      } else if (selectUserOrGroup === 2) {
         groupId = formData.group.id
      } 
      const payload = {
         ...formData,
         userId: user,
         group: groupId,
         langId: localStorage.getItem("i18nextLngId")
      }
      try {
         const response = await addDevice(payload);
         if (response.data.responseCode === 0) {
            toast.success(t('common.registers-device-successfully'));
            handleCloseDialog()
            onRefresh()
         } else {
            toast.error(response.data.message)
         }

      } catch (error) {
         handleCloseDialog()
         toast.error(error.response.data.message)

      }
   };

   return (

      <CustomDialog open transitionDuration={300} maxWidth={'xl'} onClose={handleCloseDialog} keepMounted>
         <DialogTitle>
            <div className='flex justify-between'>
               <div className='flex items-center gap-4'>
                  <p className='text-xl font-semibold '>{t('common.registers-device')}</p>
               </div>
               <GrayIconButton onClick={handleCloseDialog}>
                  <CloseIcon />
               </GrayIconButton>
            </div>
         </DialogTitle>
         <DialogContent>
            <p className='pt-5 text-sm text-[#DC2626]'>
               {t('common.required-fields-are-marked-in-red')} "*".
            </p>

            <div className='grid grid-cols-12 md:gap-x-10 gap-y-6 pt-5'>

               {/* Row: Radio Buttons + Select + IP Input */}
               <div className='col-span-12 flex flex-col md:flex-row gap-6'>

                  {/* Radio Buttons */}
                  <div className='w-full md:w-1/2'>
                     <FormControl component='fieldset' className='w-full'>
                        <RadioGroup
                           aria-label='End of repetition'
                           name='endOfRepitition'
                           row
                           value={selectUserOrGroup}
                           onChange={handleChangeSelectUserOrGroup}
                        >
                           <FormControlLabel
                              value={0}
                              control={<Radio size='small' />}
                              label={t('common.no-selection')}
                           />
                           <FormControlLabel
                              value={1}
                              control={<Radio size='small' />}
                              label={t('common.user')}
                           />
                           <FormControlLabel
                              value={2}
                              control={<Radio size='small' />}
                              label={t('common.group')}
                           />
                        </RadioGroup>

                        {/* Select user or group */}
                         {selectUserOrGroup === 0 && (
                           <CustomAutocomplete
                              className='w-full mt-4 pointer-events-none opacity-50'
                              name='userId'
                              options={usersData}
                              freeSolo={true}
                              dataType='user'
                              onDataChange={handleDataChange}
                              value={formData.userId}
                              // clear={selectUserOrGroup}
                              disabled
                           />
                        )}
                        {selectUserOrGroup === 1 && (
                           <CustomAutocomplete
                              className='w-full mt-4'
                              name='userId'
                              options={usersData}
                              freeSolo={true}
                              dataType='user'
                              onDataChange={handleDataChange}
                              value={formData.userId}
                              clear={selectUserOrGroup}
                           />
                        )}
                        
                        {selectUserOrGroup === 2 && (
                           <CustomAutocomplete
                              className='w-full mt-4'
                              name='group'
                              options={GroupData}
                              freeSolo={true}
                              dataType='grouporuser'
                              onDataChange={handleDataChange}
                              value={formData.group}

                           />
                        )}
                     </FormControl>
                  </div>

                  {/* IP Label + Input */}
                  <div className='w-full md:w-1/2 mt-[25px] ml-4'>
                     <label className='block text-sm mb-2'>IP</label>
                     <CustomInput
                        name='ip'
                        inputType='text'
                        value={formData.ip}
                        handleInputChange={handleInputChange}
                        labelEnable={false}
                        placeholder='IP'
                     />
                  </div>
               </div>

               {/* Các field còn lại giữ nguyên */}
               <div className='col-span-12 md:col-span-6'>
                  <label className='block text-sm mb-2'>{t('common.brand')}</label>
                  <CustomInput
                     name='brand'
                     inputType='text'
                     value={formData.brand}
                     handleInputChange={handleInputChange}
                     labelEnable={false}
                     placeholder={t('common.brand')}
                  />
               </div>

               <div className='col-span-12 md:col-span-6'>
                  <label className='block text-sm mb-2'>{t('common.port')}<span className='text-[#EF4444] ml-1'>*</span></label>
                  <CustomInput
                     name='port'
                     inputType='text'
                     value={formData.port}
                     handleInputChange={handleInputChange}
                     labelEnable={false}
                     placeholder={t('common.port')}
                  />
                  {errors.port && (
                     <p className="text-red-500 text-xs mt-1">{errors.port}</p>
                  )}
               </div>

               <div className='col-span-12 md:col-span-6'>
                  <label className='block text-sm mb-2'>
                     {t('common.device-sn')}
                     <span className='text-[#EF4444] ml-1'>*</span>
                  </label>
                  <CustomInput
                     name='deviceSn'
                     inputType='text'
                     value={formData.deviceSn}
                     handleInputChange={handleInputChange}
                     labelEnable={false}
                     placeholder={t('common.device-sn')}
                  />
               </div>

               <div className='col-span-12 md:col-span-6'>
                  <label className='block text-sm mb-2'>{t('common.device-attribute')}</label>
                  <CustomInput
                     name='deviceAttribute'
                     inputType='text'
                     value={formData.deviceAttribute}
                     handleInputChange={handleInputChange}
                     labelEnable={false}
                     placeholder={t('common.device-attribute')}
                  />
               </div>

               <div className='col-span-12 md:col-span-6'>
                  <label className='block text-sm mb-2'>{t('common.description')}</label>
                  <CustomInput
                     name='description'
                     inputType='text'
                     value={formData.description}
                     handleInputChange={handleInputChange}
                     labelEnable={false}
                     placeholder={t('common.description')}
                  />
               </div>
            </div>
         </DialogContent>



         <DialogActions>
            <div className='flex gap-2 px-4 py-4'>
               <ControlpanelSecondaryButton onClick={handleCloseDialog}>
                  <CloseIcon />
                  <p>{t('button.cancel')}</p>
               </ControlpanelSecondaryButton>
               <ControlpanelPrimaryButton onClick={handleSubmit} disabled={!formData.deviceSn || !formData.port}>
                  <SaveIcon />
                  <p>{t('button.save')}</p>
               </ControlpanelPrimaryButton>
            </div>
         </DialogActions>
      </CustomDialog>

   );
};

export default RegistersDeviceDialog;
